import {__t} from "@config/i18n";

export type FeeType = 'fixed' | 'interval'

export type FeeTypeItem = { [K in FeeType]: string }
export const FeeTypeItems: FeeTypeItem = {
    'fixed': __t('fee.type.fixed'),
    'interval': __t('fee.type.interval'),
}
